export enum ClickLinkTypeEnum {
  Url = 'url',
  AttachedFile = 'attachedFile',
}
